import { Component, ReactNode } from 'react'
import { prettyLog } from '../../utils'

interface Props {
  children?: ReactNode
  message?: string
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(/*_: Error*/) {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // You can log the error here
    prettyLog(
      'ErrorBoundary: 18',
      { message: this.props.message, error, errorInfo },
      'error'
    )
  }

  render() {
    if (this.state.hasError) {
      return <div style={{ display: 'none' }}>error</div>
    }

    return this.props.children
  }
}

export default ErrorBoundary
